import React, { createContext } from "react";
import useCities from "../../../utils/customHooks/useCities";

export const CityDataContext = createContext(undefined);

const CityDataProvider = ({children}) => {
    const [cities, citiesPure, loading] = useCities();
    return (
        <CityDataContext.Provider value={[cities, citiesPure, loading]}>{children}</CityDataContext.Provider>
    )
}
export default CityDataProvider;